import React from 'react';

import Toggle from '@/components/common/Toggle/Toggle';
import ToggleOptionTitle from './ToggleOptionTitle';
import styles from './toggle-option.module.scss';
import ActionsCard from '@/components/common/ActionsCard/ActionsCard';


interface IToggleOptionProps {
  isEnable: boolean;
  title?: string | JSX.Element;
  onChange: () => void;
  id: string;
  disabled?: boolean;
}

export default function ToggleOption({
  isEnable,
  title,
  onChange,
  id,
  disabled,
}: IToggleOptionProps) {
  return (
    <ActionsCard>
      <div className={styles['toggle-option']} style={disabled ? { opacity: 0.5, pointerEvents: 'none' } : undefined}>
        <div>
          {typeof title === 'string' ? (
            <ToggleOptionTitle>{title}</ToggleOptionTitle>
          ) : title}
        </div>
        <div className={styles['checkbox-wrapper']}>
          <Toggle
            id={id}
            isEnable={isEnable}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      </div>
    </ActionsCard>
  );
}
